import { MyLoanInfo } from "pages/application/applicationService";

/** Prefer API `loanKey` when present; else Encompass fallbacks (VE-01 S11). */
export const getLoanKey = (loan: MyLoanInfo): string =>
  loan.loanKey ?? loan.encompassLoanId ?? loan.loanId ?? loan.nhDealApplicationId;
